import { GetterTree } from 'vuex';
import IRootState from '@/store/types/IRootState';
import CmsState from './types/CmsState';

const getters: GetterTree<CmsState, IRootState> = {
  page: (state) => (identifier: string) => {
    return state.cmsPages.find((item: any) => item.identifier === identifier);
  },
};

export default getters;
